import { createMultiStyleConfigHelpers } from '@chakra-ui/react';

const helpers = createMultiStyleConfigHelpers(['container', 'card']);

const Sections = helpers.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: 'grid',
      justifyItems: 'center',
      gridTemplateColumns: 'repeat(auto-fit, minmax(330px, 1fr))',
      gap: '16px',
      width: '100%',
      margin: '0 auto',
      overflowY: 'auto',
    },
    card: {
      width: '100%',
      height: '100%',
    },
  },
  variants: {
    custom: (props) => ({
      container: {
        ...(props.container || {}),
      },
      card: {
        ...(props.card || {}),
      },
    }),
    responsive: (props) => ({
      container: {
        ...(props.container || {}),
        display: 'grid',
        gap: '16px',
        width: '100%',
        margin: '0 auto',
        overflowY: 'auto',
        justifyItems: 'space-between',
        alignItems: 'stretch',
        gridTemplateColumns: {
          base: 'repeat(1, minmax(0, 1fr))',
          sm: 'repeat(1, minmax(0, 1fr))',
          md: 'repeat(2, minmax(0, 1fr))',
          lg: 'repeat(3, minmax(0, 1fr))',
          '2xl': 'repeat(4, minmax(0, 1fr))',
          ...(props.gridTemplateColumns || {}),
        },
        ...(props.container || {}),
      },
      card: {
        width: '100%',
        height: '100%',
        alignSelf: 'stretch',
        justifySelf: 'stretch',
        margin: '0 auto',
        ...(props.card || {}),
      },
    }),
  },
  defaultProps: {
    variant: 'custom',
  },
});

export default Sections;
